export default __webpack_public_path__ + "static/media/icons-instagram.d94e021f.svg";